(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-your-ritual"] && !Shopify.designMode) return;
  try {
    
(() => {
  const rules = {"radiance":{"rank":1,"category":"cleanse","weekly":false},"vitality":{"rank":1,"category":"cleanse","weekly":false},"exfoliant":{"rank":2,"category":"exfoliate","weekly":true},"mask":{"rank":3,"category":"mask","weekly":true},"mist":{"rank":4,"category":"mist","weekly":false},"essence":{"rank":5,"category":"tone","weekly":false},"vitamin_c":{"rank":6,"category":"serum","weekly":false},"collagen":{"rank":7,"category":"serum","weekly":false},"restore":{"rank":8,"category":"serum","weekly":false},"eye":{"rank":9,"category":"eye","weekly":false},"renew":{"rank":10,"category":"moisturise","weekly":false},"lifting":{"rank":10,"category":"moisturise","weekly":false}};
  function plan(keys) {
    const selected = new Set(keys.filter(key => rules[key]));
    const timing = key => {
      if (rules[key].weekly) return 'weekly';
      if (selected.has('radiance') && selected.has('vitality')) {
        if (key === 'radiance') return 'daily_pm';
        if (key === 'vitality') return 'daily_am';
      }
      if (selected.has('vitamin_c') && selected.has('collagen')) {
        if (key === 'vitamin_c') return 'daily_am';
        if (key === 'collagen') return 'daily_pm';
      }
      if (selected.has('renew') && selected.has('lifting')) {
        if (key === 'renew') return 'daily_am';
        if (key === 'lifting') return 'daily_pm';
      }
      return 'daily_both';
    };
    const groups = [];
    [...selected].sort((a, b) => rules[a].rank - rules[b].rank).forEach(key => {
      if (key === 'mist' && selected.has('essence')) return;
      const rule = rules[key];
      let group = groups.find(item => item.rank === rule.rank);
      if (!group) {
        group = { rank: rule.rank, category: rule.category, items: [] };
        groups.push(group);
      }
      group.items.push({ key, timing: timing(key) });
    });
    if (selected.has('mist')) {
      groups.push({ rank: 11, category: 'mist_finish', items: [{ key: 'mist', timing: 'as_needed' }] });
    }
    return groups.map((group, index) => ({ ...group, step: index + 1 }));
  }
  if (customElements.get('praya-ritual-builder')) return;
  customElements.define('praya-ritual-builder', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.cards = [...this.querySelectorAll('[data-ritual-product]')];
      this.copy = JSON.parse(this.querySelector('[data-ritual-copy]').textContent);
      this.selectionPanel = this.querySelector('[data-ritual-selection]');
      this.resultsPanel = this.querySelector('[data-ritual-results]');
      this.list = this.querySelector('[data-ritual-list]');
      this.addEventListener('click', event => {
        const card = event.target.closest('[data-ritual-product]');
        if (card && this.contains(card)) {
          card.setAttribute('aria-pressed', String(card.getAttribute('aria-pressed') !== 'true'));
          this.updateCount();
        }
        if (event.target.closest('[data-ritual-build]')) this.showResults();
        if (event.target.closest('[data-ritual-edit]')) this.showSelection();
        if (event.target.closest('[data-ritual-clear]')) {
          this.cards.forEach(item => item.setAttribute('aria-pressed', 'false'));
          this.updateCount();
        }
      }, { signal: this.controller.signal });
      this.addEventListener('shopify:block:select', () => this.showSelection(false), { signal: this.controller.signal });
      this.updateCount();
    }
    disconnectedCallback() { this.controller?.abort(); }
    selectedKeys() {
      return this.cards.filter(card => card.getAttribute('aria-pressed') === 'true').map(card => card.dataset.ritualProduct);
    }
    updateCount() {
      const count = this.selectedKeys().length;
      this.querySelector('[data-ritual-count]').textContent = count + ' ' + this.copy.selected;
      this.querySelector('[data-ritual-build]').disabled = count === 0;
      this.querySelector('[data-ritual-clear]').disabled = count === 0;
    }
    element(tag, className, text) {
      const node = document.createElement(tag);
      node.className = className;
      if (text) node.textContent = text;
      return node;
    }
    showResults() {
      const groups = plan(this.selectedKeys());
      if (!groups.length) return;
      const fragment = document.createDocumentFragment();
      groups.forEach(group => {
        const row = this.element('li', 'praya-builder__step');
        const heading = this.element('h3', 'praya-builder__step-heading');
        heading.append(this.element('span', 'praya-builder__number', String(group.step)));
        heading.append(this.element('span', '', this.copy[group.category]));
        row.append(heading);
        const items = this.element('div', 'praya-builder__step-products');
        group.items.forEach(item => {
          const template = [...this.querySelectorAll('template[data-ritual-template]')].find(t => t.dataset.ritualTemplate === item.key);
          if (!template) return;
          const content = template.content.cloneNode(true);
          content.querySelector('[data-ritual-timing]').textContent = this.copy[item.timing];
          items.append(content);
        });
        row.append(items);
        if (group.items[0].timing === 'weekly') row.append(this.element('p', 'praya-builder__note', this.copy.weekly_note));
        if (group.category === 'mist') row.append(this.element('p', 'praya-builder__note', this.copy.mist_note));
        if (group.category === 'mist_finish') row.append(this.element('p', 'praya-builder__note', this.copy.mist_finish_note));
        fragment.append(row);
      });
      this.list.replaceChildren(fragment);
      const keys = new Set(this.selectedKeys());
      const notes = this.querySelector('[data-ritual-notes]');
      notes.replaceChildren();
      [['radiance', 'vitality', 'cleanser_note'], ['vitamin_c', 'collagen', 'serum_note'], ['renew', 'lifting', 'moisturiser_note']].forEach(([a, b, note]) => {
        if (keys.has(a) && keys.has(b) && this.copy[note]) notes.append(this.element('p', '', this.copy[note]));
      });
      notes.hidden = !notes.childElementCount;
      this.selectionPanel.hidden = true;
      this.resultsPanel.hidden = false;
      this.setProgress(true);
      this.resultsPanel.querySelector('h2').focus();
    }
    showSelection(focus = true) {
      this.resultsPanel.hidden = true;
      this.selectionPanel.hidden = false;
      this.setProgress(false);
      if (focus) this.selectionPanel.querySelector('h2').focus();
    }
    setProgress(results) {
      const panel = results ? this.resultsPanel : this.selectionPanel;
      panel.querySelector('.praya-builder__header').after(this.querySelector('.praya-builder__progress'));
      this.querySelectorAll('[data-ritual-progress]').forEach((node, index) => {
        node.classList.toggle('is-active', results ? index === 1 : index === 0);
        if (results ? index === 1 : index === 0) node.setAttribute('aria-current', 'step');
        else node.removeAttribute('aria-current');
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-accordion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('praya-ingredients-accordion')) {
  customElements.define('praya-ingredients-accordion', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.rows = [...this.querySelectorAll('[data-ingredient-row]')];
      this.viewer = this.querySelector('[data-ingredient-image]');
      this.media = this.querySelector('.praya-ingredients__viewer');
      this.desktopHome = this.querySelector('.praya-ingredients__layout');
      this.mobile = window.matchMedia('(max-width: 1024px)');
      this.mobile.addEventListener('change', () => this.placeImage(), {signal});
      this.placeImage();
      this.addEventListener('click', event => {
        const summary = event.target.closest('.praya-ingredients__summary');
        if (summary && this.contains(summary) && !summary.parentElement.open) this.select(summary.parentElement);
      }, {signal});
      this.addEventListener('shopify:block:select', event => {
        const row = this.rows.find(item => item.dataset.ingredientRow === event.detail.blockId);
        if (row) { this.select(row); row.open = true; }
      }, {signal});
    }
    placeImage() {
      if (this.mobile.matches) {
        if (this.activeRow) {
          this.activeRow.querySelector('.praya-ingredients__details').appendChild(this.media);
          this.media.hidden = false;
        } else {
          this.media.hidden = true;
        }
      } else {
        this.desktopHome.appendChild(this.media);
        this.media.hidden = false;
      }
    }
    select(row) {
      this.activeRow = row;
      this.placeImage();
      this.rows.forEach(item => {
        if (item !== row) item.open = false;
        item.classList.toggle('is-active', item === row);
      });
      const template = row.querySelector('[data-ingredient-template]');
      this.viewer.replaceChildren(template.content.cloneNode(true));
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["praya-expandable-card"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('praya-card-carousel')) {
  customElements.define('praya-card-carousel', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      this.grid = this.querySelector('.praya-expandable__grid--swipe');
      this.dots = Array.from(this.querySelectorAll('.praya-expandable__dot'));
      if (!this.grid || !this.dots.length) return;
      this.cards = Array.from(this.grid.children);
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelector('.praya-expandable__dots').hidden = false;
      this.update = () => {
        const rect = this.grid.getBoundingClientRect();
        const max = this.grid.scrollWidth - this.grid.clientWidth;
        const rtl = getComputedStyle(this.grid).direction === 'rtl';
        const position = Math.abs(this.grid.scrollLeft);
        const targets = this.cards.map(card => {
          const box = card.getBoundingClientRect();
          return Math.max(0, Math.min(max, position + (rtl ? rect.right - box.right : box.left - rect.left)));
        });
        let active = 0;
        targets.forEach((target, index) => {
          if (Math.abs(target - position) < Math.abs(targets[active] - position)) active = index;
        });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-pressed', String(index === active)));
      };
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => {
        const rect = this.grid.getBoundingClientRect();
        const card = this.cards[index].getBoundingClientRect();
        const rtl = getComputedStyle(this.grid).direction === 'rtl';
        this.grid.scrollBy({
          left: rtl ? card.right - rect.right : card.left - rect.left,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }, {signal}));
      this.grid.addEventListener('scroll', this.update, {passive:true, signal});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.grid);
      this.update();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ritual-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('praya-ritual-videos')) {
    customElements.define('praya-ritual-videos', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.player = this.querySelector('[data-ritual-player]');
        this.buttons = [...this.querySelectorAll('[data-ritual-select]')];
        this.viewer = this.querySelector('.praya-ritual__viewer');
        this.desktopHome = this.querySelector('.praya-ritual__layout');
        this.mobile = window.matchMedia('(max-width: 1024px)');
        this.mobile.addEventListener('change', () => this.placeViewer(), { signal });
        this.querySelectorAll('[data-ritual-row]').forEach(row => {
          row.addEventListener('toggle', () => {
            if (!row.open && row.contains(this.viewer)) this.player.querySelector('video')?.pause();
          }, { signal });
        });
        this.addEventListener('click', (event) => {
          const summary = event.target.closest('.praya-ritual__summary');
          if (summary && this.contains(summary) && !summary.parentElement.open) {
            this.querySelectorAll('[data-ritual-row]').forEach(row => { if (row !== summary.parentElement) row.open = false; });
            const choice = summary.parentElement.querySelector('[data-ritual-select]');
            if (choice && !choice.disabled) this.select(choice, true);
          }
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const button = this.buttons.find(item => item.dataset.ritualSelect === event.detail.blockId);
          if (button && !button.disabled) { this.select(button, false); button.closest("details").open = true; }
        }, { signal });
        const first = this.buttons.find(button => !button.disabled);
        if (first) this.select(first, false);
        else this.placeViewer();
      }
      placeViewer() {
        if (this.mobile.matches) {
          const row = this.activeButton?.closest('[data-ritual-row]');
          if (row) {
            row.querySelector('.praya-ritual__details').appendChild(this.viewer);
            this.viewer.hidden = false;
            if (!row.open) this.player.querySelector('video')?.pause();
          } else {
            this.viewer.hidden = true;
          }
        } else {
          this.desktopHome.appendChild(this.viewer);
          this.viewer.hidden = false;
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.player?.querySelector('video')?.pause();
      }
      select(button, autoplay) {
        const id = button.dataset.ritualSelect;
        const template = [...this.querySelectorAll('template[data-ritual-template]')].find(item => item.dataset.ritualTemplate === id);
        if (!template) return;
        this.player.querySelector('video')?.pause();
        this.activeButton = button;
        this.querySelectorAll('[data-ritual-row]').forEach(row => {
          if (row !== button.closest('[data-ritual-row]')) row.open = false;
        });
        this.placeViewer();
        this.player.replaceChildren(template.content.cloneNode(true));
        this.buttons.forEach(item => {
          const selected = item === button;
          item.closest('[data-ritual-row]').classList.toggle('is-active', selected);
        });
        const video = this.player.querySelector('video');
        if (!video) return;
        video.setAttribute('aria-label', button.getAttribute('aria-label'));
        this.querySelector('[data-ritual-status]').textContent = button.getAttribute('aria-label');
        if (autoplay) video.play().catch(() => { video.controls = true; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-proof"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('praya-results-proof')) {
  customElements.define('praya-results-proof', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.mobile = window.matchMedia('(max-width: 767.98px)');
      this.mobile.addEventListener('change', () => this.positionResults(), options);
      this.positionResults();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-proof-select]');
        if (button && this.contains(button)) this.select(button.dataset.proofSelect);
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        if (event.detail?.blockId) this.select(event.detail.blockId);
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
    positionResults() {
      const row = this.querySelector('.results-proof__product.is-selected');
      const stats = this.querySelector('.results-proof__stats');
      const image = this.querySelector('.results-proof__image-wrap');
      const grid = this.querySelector('.results-proof__grid');
      if (!row || !stats || !image || !grid) return;
      if (this.mobile.matches) {
        row.after(stats, image);
      } else {
        grid.append(stats, image);
      }
    }
    select(id) {
      const buttons = [...this.querySelectorAll('[data-proof-select]')];
      if (!buttons.some(button => button.dataset.proofSelect === id)) return;
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.proofSelect === id)));
      this.querySelectorAll('[data-proof-row]').forEach(row => row.classList.toggle('is-selected', row.dataset.proofRow === id));
      this.querySelectorAll('[data-proof-panel]').forEach(panel => { panel.hidden = panel.dataset.proofPanel !== id; });
      this.querySelectorAll('[data-proof-image]').forEach(image => { image.hidden = image.dataset.proofImage !== id; });
      this.querySelectorAll('[data-proof-button]').forEach(button => { button.hidden = button.dataset.proofButton !== id; });
      this.positionResults();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ritual-steps"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('praya-ritual-scroll')) {
  customElements.define('praya-ritual-scroll', class extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.praya-routine__scroll');
      this.bar = this.querySelector('.praya-routine__bar');
      this.update = () => {
        const width = this.scroller.clientWidth;
        const total = this.scroller.scrollWidth;
        const overflow = total - width;
        this.bar.hidden = overflow <= 1;
        const thumb = this.bar.firstElementChild;
        const ratio = width / Math.max(total, 1);
        thumb.style.width = (ratio * 100) + '%';
        const progress = overflow > 0 ? Math.min(1, Math.abs(this.scroller.scrollLeft) / overflow) : 0;
        thumb.style.marginInlineStart = (progress * (1 - ratio) * 100) + '%';
      };
      this.scroller.addEventListener('scroll', this.update, {passive:true});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.scroller);
      this.observer.observe(this.scroller.firstElementChild);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.scroller?.removeEventListener('scroll', this.update);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-text"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = () => {
    document.querySelectorAll('[data-static-text-carousel]').forEach((carousel) => {
      if (carousel.dataset.carouselReady || !carousel.classList.contains('static-text__mobile-carousel--enabled')) return;
      carousel.dataset.carouselReady = 'true';

      const track = carousel.querySelector('[data-static-carousel-track]');
      const slides = Array.from(track.querySelectorAll('.static-text__item'));
      const previous = carousel.querySelector('[data-static-carousel-previous]');
      const next = carousel.querySelector('[data-static-carousel-next]');
      const mobile = window.matchMedia('(max-width: 767.98px)');
      let timer;

      if (slides.length < 2) {
        if (previous) previous.hidden = true;
        if (next) next.hidden = true;
        return;
      }

      const currentIndex = () => {
        const positions = slides.map((slide) => Math.abs(track.scrollLeft - slide.offsetLeft));
        return positions.indexOf(Math.min(...positions));
      };

      const move = (change) => {
        if (!mobile.matches) return;
        const index = (currentIndex() + change + slides.length) % slides.length;
        track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      };

      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (mobile.matches && carousel.dataset.autoplay === 'true') {
          timer = window.setInterval(() => move(1), Number(carousel.dataset.speed) || 5000);
        }
      };

      previous?.addEventListener('click', () => { move(-1); start(); });
      next?.addEventListener('click', () => { move(1); start(); });
      carousel.addEventListener('pointerdown', stop);
      carousel.addEventListener('pointerup', start);
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      mobile.addEventListener('change', start);
      start();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-image-with-text"] && !Shopify.designMode) return;
  try {
    
  class StickyImageWithText extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('.sticky-image-with-text__media');
      this.mediaCol = this.querySelector('.sticky-image-with-text__media-col');
      if (!this.media || !this.mediaCol) return;

      this.updateStickyPosition = this.updateStickyPosition.bind(this);
      this.updateStickyPosition();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.updateStickyPosition);
        this.resizeObserver.observe(this.media);
      }

      window.addEventListener('resize', this.updateStickyPosition, { passive: true });
      window.addEventListener('load', this.updateStickyPosition, { once: true });
    }

    updateStickyPosition() {
      const mediaHeight = this.media?.getBoundingClientRect().height || 0;
      if (mediaHeight <= 0) return;

      this.style.setProperty('--sticky-media-height', `${mediaHeight}px`);

      const topOffset = Math.max(0, (window.innerHeight - mediaHeight) / 2);
      this.mediaCol.style.setProperty('--top-custom', `${Math.round(topOffset)}px`);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.updateStickyPosition);
    }
  }

  if (!customElements.get('sticky-image-with-text')) {
    customElements.define('sticky-image-with-text', StickyImageWithText);
  }

  } catch(e) { console.error(e); }
})();
})();
